module.exports = __webpack_public_path__ + "images/buttons/btn-playstore.2d8bf64328f6c2666c1d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/buttons/btn-playstore.png
// module id = Q67s
// module chunks = 2